module.exports = __webpack_public_path__ + "static/img/01-人大附中西山学校1.87e260c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/01-人大附中西山学校1.png
// module id = elE+
// module chunks = 0